import React from 'react'
import { LandingPageImport } from '../Import'
const { TextAnimate } = LandingPageImport

export default function EventClock() {
    return (
        <>
            <div className="event_clock">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="clock_bg">
                                <div className="row align-items-center">
                                    <div className="col-lg-4">
                                        <div className='clock_heading'>
                                            <h4>
                                                <TextAnimate text="WRRIC “25”" />
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="col-lg-2"></div>

                                    <div className="col-lg-6">
                                        <div className="timer">
                                            <div className="time_box">
                                                <span className="time_value">119</span><br />
                                                <span className="time_text">DAYS</span>
                                            </div>
                                            <div className="time_box">
                                                <span className="time_value">22</span><br />
                                                <span className="time_text">HOURS</span>
                                            </div>
                                            <div className="time_box">
                                                <span className="time_value">18</span><br />
                                                <span className="time_text">MINUTES</span>
                                            </div>
                                            <div className="time_box">
                                                <span className="time_value">44</span><br />
                                                <span className="time_text">SECONDS</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
